/**
 * Series Navigation - Smooth Scroll with Easing
 * Gallery-quality anchor navigation with deceleration curve
 * Respects prefers-reduced-motion accessibility preference
 */

class SeriesNavigation {
    constructor(element) {
        this.element = element;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.init();
    }

    init() {
        // Intercept anchor links within navigation
        const links = this.element.querySelectorAll('a[href^="#"]');
        links.forEach(link => {
            link.addEventListener('click', (e) => this.handleClick(e));
        });
    }

    handleClick(event) {
        event.preventDefault();

        const href = event.currentTarget.getAttribute('href');
        const targetId = href.slice(1);
        const targetElement = document.getElementById(targetId);

        if (!targetElement) return;

        // Respect user's motion preferences
        if (this.prefersReducedMotion) {
            targetElement.scrollIntoView({ block: 'start' });
            return;
        }

        // Calculate scroll target with offset
        const headerOffset = this.getHeaderOffset();
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const scrollTarget = targetPosition - headerOffset;

        this.smoothScrollTo(scrollTarget, 800); // 800ms duration for elegant deceleration
    }

    getHeaderOffset() {
        // Dynamic offset based on viewport
        const viewportWidth = window.innerWidth;

        if (viewportWidth < 750) {
            return 64; // 4rem mobile
        } else if (viewportWidth < 990) {
            return 80; // 5rem tablet
        } else {
            return 96; // 6rem desktop
        }
    }

    /**
     * Smooth scroll with cubic ease-in-out curve
     * Creates natural deceleration like fine gallery elevator
     */
    smoothScrollTo(target, duration) {
        const start = window.pageYOffset;
        const distance = target - start;
        const startTime = performance.now();

        const easeInOutCubic = (t) => {
            return t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const scroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutCubic(progress);

            window.scrollTo(0, start + (distance * eased));

            if (progress < 1) {
                requestAnimationFrame(scroll);
            }
        };

        requestAnimationFrame(scroll);
    }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeriesNavigation);
} else {
    initSeriesNavigation();
}

function initSeriesNavigation() {
    const navElements = document.querySelectorAll('.series-navigation');
    navElements.forEach(nav => new SeriesNavigation(nav));
}
